module.exports = __webpack_public_path__ + "img/up.21b32140.png";